import React, { Component, Fragment } from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import ReactPlaceholder from 'react-placeholder'
import { connect } from 'react-redux'

import { CardBrands } from '../../CardBrands'
import { VirtualVoucher } from './VirtualVoucher'

import { Loading } from '../../Loading'
import { SummaryPlaceholder } from '.'
import { CatalogCurrencyLabel } from 'Shared/CurrencyLabel'

class Summary extends Component {
  cardBrandIsloading (qty, onlyCash) {
    return this.props.isRedeemPointsMoreOthers &&
      !this.props.cardBrands.isLoading ? (
        <div
          className={`cart-brands row px-2 pb-3 ${
            qty === 0 ? 'border-dotted-top border-color-ui-3 pt-2' : ''
          }`}
        >
          <div className='col-12 justify-content-center align-self-center'>
            { onlyCash
              ? <Fragment>
                <p className='txt-body-sm'>
                  <strong>
                    Pague com cartão de crédito.
                  </strong>
                </p>
                <p className='txt-body-sm'>
                  Confira as bandeiras aceitas.
                </p>
              </Fragment>
              : <Fragment>
                <p className='txt-body-sm'>
                  <strong>
                    {`Sem ${this.props.pointsName} suficientes? Não se preocupe.`}
                  </strong>
                </p>
                <p className='txt-body-sm'>
                  Você pode completar seu resgate com dinheiro.
                </p>
              </Fragment>
            }
            <CardBrands brands={this.props.cardBrands.brands} />
          </div>
        </div>
      ) : (
        ''
      )
  }

  convertCurrency (value, fixed) {
    const number = parseFloat(value)

    return number
      .toFixed(fixed)
      .replace('.', ',')
      .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
  }

  render () {
    const { price = 0, priceCash = 0, count = 0, shipping, ready } = this.props

    const total = price + (shipping.total || 0)
    const totalCash = priceCash + (shipping.totalCash || 0)

    return (
      <ReactPlaceholder
        ready={ready}
        customPlaceholder={<SummaryPlaceholder />}
      >
        <div className='cart-side col-12 col-md-4 px-0 py-0'>
          <div className='col-12 border-ui-3 radius bg-white px-0 py-0'>
            <div className='col-12 py-3 px-3 mx-0 border-color-ui-3 border-bottom'>
              <h3 className='color-title txt-font-body'>Resumo do pedido</h3>
            </div>
            <div className='cart-subtotal col-12 pb--1 mx-0'>
              <div className='row product-brand py-2 px-2  border-dotted-bottom border-color-ui-3'>
                <div
                  id='cart-subtotal-quantity'
                  className='col-7 txt-title-3 txt-body-sm txt-font-body color-ui-2 txt-left  justify-content-center align-self-center'
                >
                  {`Subtotal (${count} ${count <= 1 ? 'item' : 'itens'}):`}
                </div>
                <div
                  id='cart-subtotal-price'
                  className='col-5 txt-title-3 txt-body-sm txt-subtitle txt-font-body color-ui-2 txt-right  justify-content-center align-self-center'
                >
                  <Loading
                    ready={!this.props.isUpdating && !this.props.isLoading}
                  >
                    <strong id='cart-subtotal-price-value'>
                      <CatalogCurrencyLabel
                        price={{ points: price, cash: priceCash }}
                        checkCashOnly
                      />
                    </strong>
                  </Loading>
                </div>
              </div>
              {this.props.hasItemsDifferentVirtualVoucher ? (
                <div className='row product-brand py-2  px-2  border-dotted-bottom border-color-ui-3'>
                  <div className='col-7 txt-title-3 txt-body-sm txt-font-body color-ui-2 txt-left justify-content-center align-self-center'>
                    Frete:
                  </div>
                  <div className='col-5 txt-title-3 txt-body-sm txt-subtitle txt-font-body color-brand-4 txt-right justify-content-center align-selfe-center'>
                    <Loading ready={!shipping.isLoading}>
                      <strong id='cart-subtotal-shipping-value'>
                        {shipping.total ? (
                          <CatalogCurrencyLabel
                            price={{
                              points: shipping.total,
                              cash: shipping.totalCash
                            }}
                            checkCashOnly
                          />
                        ) : (
                          '-'
                        )}
                      </strong>
                    </Loading>
                  </div>
                </div>
              ) : (
                ''
              )}
              {this.props.hasItemsVirtualVoucher ? (
                <div className='row product-brand py-2  px-2  border-dotted-bottom border-color-ui-3'>
                  <VirtualVoucher {...this.props} />
                </div>
              ) : (
                ''
              )}

              <div className='cart-shipping row py-1 px-2'>
                <div className='cart-total-value col-7 txt-body txt-font-body txt-left justify-content-center align-self-center'>
                  Valor Total:
                </div>
                <div className='cart-total-value col-5 txt-body color-brand-1 txt-font-body txt-right justify-content-center align-self-center'>
                  <Loading
                    ready={
                      !this.props.isUpdating &&
                      !this.props.isLoading &&
                      !shipping.isLoading
                    }
                  >
                    <strong id='cart-subtotal-total-value'>
                      <CatalogCurrencyLabel
                        price={{
                          points: total,
                          cash: totalCash
                        }}
                        checkCashOnly
                      />
                    </strong>
                  </Loading>
                </div>
              </div>
              {count > 0 ? (
                <div>
                  <div className='cart-done row px-2 pt-1 pb-2'>
                    <div className='col-12 justify-content-center align-self-center'>
                      <Link
                        className='btn btn-featured btn-icon txt-button txt-font-body'
                        to='/checkout'
                        role='button'
                      >
                        <i className='icon icon_gift' aria-hidden='true' />
                        { this.props.onlyCash ? 'COMPRAR AGORA' : 'RESGATAR AGORA' }
                      </Link>
                    </div>
                  </div>

                  <div className='float-button bg-white px-2 pb-1 pt-0 row mx-0 d-none'>
                    <div className='col-12 mx-0 px-0 row cart-shipping'>
                      <p className='col-7 px-0 txt-body txt-font-body txt-left justify-content-center align-self-center'>
                        Valor Total:
                      </p>
                      <p className='col-5 px-0 txt-body txt-font-body txt-right justify-content-center align-self-center'>
                        <Loading
                          ready={
                            !this.props.isUpdating &&
                            !this.props.isLoading &&
                            !shipping.isLoading
                          }
                        >
                          <strong id='cart-subtotal-total-value-mobile'>
                            <CatalogCurrencyLabel
                              price={{
                                points: total,
                                cash: totalCash
                              }}
                              checkCashOnly
                            />
                          </strong>
                        </Loading>
                      </p>
                    </div>
                    <div className='col-12 px-0'>
                      <Link
                        className='btn btn-ssm btn-featured nowrap txt-center py-1'
                        to='/checkout'
                        role='button'
                      >
                        { this.props.onlyCash ? 'COMPRAR AGORA' : 'RESGATAR AGORA' }
                      </Link>
                    </div>
                  </div>
                </div>
              ) : (
                ''
              )}

              {this.cardBrandIsloading(count, this.props.onlyCash)}
            </div>
          </div>
        </div>
      </ReactPlaceholder>
    )
  }
}

Summary.propTypes = {
  price: PropTypes.number,
  priceCash: PropTypes.number,
  count: PropTypes.number,
  shipping: PropTypes.object.isRequired,
  pointsName: PropTypes.string.isRequired,
  isRedeemPointsMoreOthers: PropTypes.bool,
  cardBrands: PropTypes.object,
  hasItemsVoucherVirtual: PropTypes.bool,
  everyItemsVirtualVoucher: PropTypes.bool,
  hasItemsDifferentVirtualVoucher: PropTypes.bool,
  hasItemsVirtualVoucher: PropTypes.bool,
  ready: PropTypes.bool,
  isUpdating: PropTypes.bool,
  isLoading: PropTypes.bool,
  onlyCash: PropTypes.bool
}

const mapStateToProps = ({ onlyCash }) => ({
  onlyCash
})
export default connect(
  mapStateToProps,
  null
)(Summary)



// WEBPACK FOOTER //
// ./src/features/Cart/Summary/Summary.js